// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import BoomStepper from '../../components/BoomStepper';
import { useBoomHomeContext } from '../../contexts/BoomHomeContext';

import selectBoomStepperProps from './BoomStepper.selector';

type PropsType = {
  className?: string;
};

const BoomStepperContainer = (ownProps: PropsType) => {
  const { currentStepId } = useBoomHomeContext();

  const selectorProps = useMemo(() => ({ stepId: currentStepId }), [currentStepId]);
  const selectedProps = useSelector((state) => selectBoomStepperProps(state, selectorProps));

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <BoomStepper {...enhancedProps} />;
};

export default BoomStepperContainer;
